/**
 * LoadingScreen - 3D模型加载骨架屏组件
 */

import { useLanguage } from '../../context/LanguageContext';
import styles from './LoadingScreen.module.css';

export default function LoadingScreen({
    message,
    progress = null, // 0-100 可选进度值
}) {
    const { t } = useLanguage();
    const displayMessage = message || t('viewer3d.loading');

    return (
        <div className={styles.container}>
            <div className={styles.content}>
                {/* Spinner */}
                <div className={styles.spinnerContainer}>
                    <div className={styles.spinner}></div>
                    <div className={styles.spinnerInner}></div>
                </div>

                {/* Message */}
                <p className={styles.message}>{displayMessage}</p>

                {/* Progress Bar (optional) */}
                {progress !== null && (
                    <div className={styles.progressContainer}>
                        <div className={styles.progressBar}>
                            <div
                                className={styles.progressFill}
                                style={{ width: `${progress}%` }}
                            />
                        </div>
                        <span className={styles.progressText}>{Math.round(progress)}%</span>
                    </div>
                )}

                {/* Hint */}
                <p className={styles.hint}>
                    {t('viewer3d.loadingHint')}
                </p>
            </div>
        </div>
    );
}
